import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "@/lib/auth";
import { useCompany } from "@/lib/company";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const { previewMode } = useCompany();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        <div className="animate-pulse text-sm">Loading GoEcom…</div>
      </div>
    );
  }

  // A magic-link preview (token in the URL) is allowed without an account.
  if (status === "anon" && !previewMode) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
